import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/core/auth/AuthContext';
import { activityListService } from '../services/activityList.service';
import type { ActivityFilters } from '../types/activityList.types';

export function useActivityList() {
  const { profile } = useAuth();
  const companyId = profile?.company_id || '';
  
  const [filters, setFilters] = useState<ActivityFilters>({ 
    query: '', 
    module: 'all',
    action: 'all',
    userId: 'all',
    dateFrom: '',
    dateTo: '',
    page: 1,
    pageSize: 30
  });

  const query = useQuery({
    queryKey: ['settings', 'activity', 'list', companyId, filters],
    queryFn: () => activityListService.getLogs(companyId, filters),
    enabled: !!companyId,
  });

  const usersQuery = useQuery({
    queryKey: ['settings', 'activity', 'users', companyId],
    queryFn: () => activityListService.getUsers(companyId),
    enabled: !!companyId,
  });

  const updateFilters = (newFilters: Partial<ActivityFilters>) => {
    setFilters(prev => ({ ...prev, ...newFilters, page: newFilters.page || 1 }));
  };

  return {
    logs: query.data?.data || [],
    totalCount: query.data?.count || 0,
    users: usersQuery.data || [],
    filters,
    isLoading: query.isLoading,
    setFilters: updateFilters,
    refresh: query.refetch
  };
}
